var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    { staticClass: "pa-4", attrs: { flat: "" } },
    [
      _c("v-card-title", { staticClass: "pb-2" }, [
        _c("h3", [_vm._v("Pin Details")]),
      ]),
      _c("base-form", {
        ref: "pinFormRef",
        on: { submit: _vm.savePin },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ invalid }) {
              return [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-text-field", {
                          attrs: {
                            label: "Pin Title",
                            value: _vm.pinForm.title,
                            rules: "required",
                            placeholder: "Enter pin title",
                            disabled: _vm.readonly,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(_vm.pinForm, "title", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-select", {
                          attrs: {
                            label: "Pin Type",
                            value: _vm.pinForm.pinType,
                            items: _vm.pinTypes,
                            placeholder: "Select pin type",
                            clearable: "",
                            disabled: _vm.readonly,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(_vm.pinForm, "pinType", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-autocomplete", {
                          attrs: {
                            label: "Terminal Block",
                            value: _vm.pinForm.terminalBlockId,
                            items: _vm.terminalBlocks,
                            "item-text": "serialNumber",
                            "item-value": "id",
                            placeholder: "Select Terminal Block",
                            clearable: "",
                            disabled: _vm.readonly,
                          },
                          on: {
                            "update:value": function ($event) {
                              return _vm.$set(
                                _vm.pinForm,
                                "terminalBlockId",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("base-text-field", {
                          attrs: {
                            label: "Pin Direction",
                            value: _vm.pinDirectionDisplay,
                            disabled: "",
                            readonly: "",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                !_vm.readonly
                  ? _c(
                      "v-row",
                      { staticClass: "mt-4" },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "d-flex justify-end",
                            attrs: { cols: "12" },
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "mr-3",
                                attrs: {
                                  color: "grey",
                                  outlined: "",
                                  disabled: _vm.isLoading,
                                },
                                on: { click: _vm.resetForm },
                              },
                              [_vm._v("Reset")]
                            ),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "primary",
                                  type: "submit",
                                  loading: _vm.isLoading,
                                  disabled: invalid,
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.isEditing
                                        ? "Update Pin"
                                        : "Create Pin"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }